<template>
  <basic-container>
    <section class="section">
      <div class="title">基本信息</div>
      <div class="content">
        <div class="content_left">
          <div>
            <span>房间号：</span>
            <span>{{ detailData.code || "-" }}</span>
          </div>
          <div>
            <span>开始时间：</span>
            <span>{{ detailData.createTime || "-" }}</span>
          </div>
          <div>
            <span>会议时长：</span>
            <span>{{ detailData.duration || "-" }}</span>
          </div>
          <div>
            <span>总参会用户数：</span>
            <span>{{ detailData.totalNum }}</span>
          </div>
        </div>
        <div class="content_right">
          <div>
            <span>会议状态：</span>
            <span>{{ detailData.status === 1 ? "进行中" : "结束" }}</span>
          </div>
          <div>
            <span>结束时间：</span>
            <span>{{ detailData.endTime || "-" }}</span>
          </div>
          <div>
            <span>当前在线用户数：</span>
            <span>{{
              detailData.status === 1 ? detailData.onlineNum : 0
              }}</span>
          </div>
          <div>
            <span>RTC,IM方案类型：</span>
            <span>{{ detailData.raiType !== '' ? ['即构RTC+即构IM', '网易RTC+网易IM', '腾讯RTC+网易IM',
              '即构RTC+网易IM'][+detailData.raiType] : '-'}}</span>
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="title">供应商信息</div>
      <div class="content">
        <div class="content_left">
          <div class="content_item">
            <span>云桌面供应商：</span>
            <span v-show="detailData.cloudType === 1">威尔云</span>
            <span v-show="detailData.cloudType === 2">阿里云</span>
            <span v-show="detailData.cloudType === 3">腾讯云</span>

            <span class="_cloud_btn" v-loading="loadingBtn" @click="toCloudDetail">查看详情</span>
          </div>
          <div>
            <span>房间号 ID：</span>
            <span>{{ $route.query.id || "-" }}</span>
          </div>
          <div class="content_item">
            <!-- <span>RTC 供应商：</span>
            <span>即构</span> -->
          </div>
        </div>
        <div class="content_right">
          <div>
            <span>云桌面 ID：</span>
            <span>
              {{ detailData.aliDesktopId || "-" }}
            </span>
          </div>
          <div class="content_item">
            <!-- <span>IM 供应商：</span>
            <span>即构 </span> -->
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="title">成员列表</div>
    </section>
    <el-table :data="tableData" border style="width: 100%; margin-top: 10px" v-loading="loading">
      <el-table-column prop="uid" label="uid" width="180">
        <template slot-scope="scope">
          <span>
            {{ scope.row.uid || "-" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="username" label="用户昵称">
        <template slot-scope="scope">
          <span>
            {{ scope.row.username || "-" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="mobile" label="手机号码">
        <template slot-scope="scope">
          <span>
            {{ scope.row.mobile || "-" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 1"> 在线 </span>
          <span v-else> 离线</span>
        </template>
      </el-table-column>
      <el-table-column prop="dType" label="类型">
        <template slot-scope="scope">
          <span v-show="scope.row.dType === 0"> 移动端-安卓 </span>
          <span v-show="scope.row.dType === 1"> 移动端-iOS </span>
          <span v-show="scope.row.dType === 2"> TV端 </span>
          <span v-show="scope.row.dType === 3"> pc端 </span>
          <span v-show="scope.row.dType === 4"> MAC </span>
          <span v-show="scope.row.dType === 5"> H5手机 </span>
          <span v-show="scope.row.dType === 6"> H5电脑 </span>
        </template>
      </el-table-column>
      <el-table-column prop="ip" label="ip" width="150px">
        <template slot-scope="scope">
          {{ `${scope.row.ip || '-'}` }}
          <br />
          {{ ` ${scope.row.address || '-'} ` }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="开始时间"> </el-table-column>
      <el-table-column prop="leaveTime" label="结束时间">
        <template slot-scope="scope">
          <span>
            {{ scope.row.leaveTime || "-" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="ismain" label="用户身份">
        <template slot-scope="scope">
          <span v-if="scope.row.ismain === 0"> 参会人 </span>
          <span v-else-if="scope.row.ismain === 1"> 房主</span>
          <span v-else> '-'</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <!-- 有房间号跟uid 才可以点击 -->
          <el-button :disabled="!scope.row.uid || !detailData.code" @click="handleClick(scope.row)" type="text"
            size="small">详情</el-button>

        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="params.current" :page-sizes="[10, 20, 40, 50, 100]" :page-size="params.size"
      layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>
  </basic-container>
</template>
<script>
import { getDwSdkCastRealtimeCloudUsersFactApi } from "@/api/imageManagement";
import { detailRoominfo, userList } from "@/api/rabbit/metting-manage";

export default {
  data () {
    return {
      roomInfoLoading: false,
      loadingBtn: false,
      loading: false,
      total: 0,
      params: {
        size: 10,
        current: 1,
      },
      formLabelWidth: "120px",
      tableData: [],
      detailData: {},
    };
  },
  mounted () {
    this.getDataList();
    this.getDetailRoominfo();
  },
  watch: {
    '$route.path': {
      async handler (val) {
        if (val === '/rabbit/metting-detail') {
         await this.getDataList();
         await this.getDetailRoominfo();
        }
      },
      deep: true
    },
  },
  methods: {
    toCloudDetail () {
      this.loadingBtn = true
      console.log(this.detailData)
      getDwSdkCastRealtimeCloudUsersFactApi({ cloudType: this.detailData.cloudType, roomId: this.detailData.id }).then(res => {
        console.log(res)
        this.loadingBtn = false
        this.$router.push({
          path: '/rabbit/cloud-app',
          query: {
            uid: res.data.data.sdkUserId,
            roomid: this.detailData.id,
            code: this.detailData.code,
          },
        })
      })
    },

    handleClick (row) {
      // 跳转时uid 有TV_ 或者 Cloud_ 清除处理
      console.log('row', row)
      let id = row.uid
      if (row.uid.indexOf('TV_') !== -1 || row.uid.indexOf('Cloud_') !== -1) {
        id = id.split('_')[1]
      }
      this.$router.push({
        path: "/rabbit/user-detail",
        query: {
          uid: id,
          code: this.detailData.code,
          username: row.username,
          mobile: row.mobile,
          uuid: row.uuid,
          roomid: row.roomid,
          dType: row.dType,
          appId: row.appId,
          createTime: this.detailData.createTime,
        },
      });
    },
    // 更该tab 名字为：房间号+会议详情
    editTitle (id, code = '') {
      let url = window.location.hash.replace(/#\/rabbit\/metting-detail/, 'tab-/rabbit/metting-detail');
      let tab = document.getElementById(url);
      let newTitle = code
      const nowId = this.$route.query.id;
      /** 根据id判断是否是此标签页需要替换tabname */
      if (nowId !== id) return;
      if (tab && tab.innerText !== newTitle) {
        const code = tab.innerText;
        if (code.includes(newTitle)) return;
        tab.insertAdjacentHTML('afterbegin', newTitle)
      }
    },
    handleSizeChange (val) {
      this.params.size = val;
      this.getDataList();
    },
    handleCurrentChange (val) {
      this.params.current = val;
      this.getDataList();
    },
    getDataList () {
      this.loading = true;
      const _data = { ...this.params, id: this.$route.query.id };
      userList(_data)
        .then((res) => {
          const data = res.data.data;
          this.total = data.total;
          this.tableData = data.records;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getDetailRoominfo() {
      const id = this.$route.query.id
      if (!id || this.roomInfoLoading) return
      this.roomInfoLoading = true
      const { data } = await detailRoominfo(id)
      this.roomInfoLoading = false
      console.log("🚀 ~ getDetailRoominfo ~ res:", data)
      this.$set(this, 'detailData', data.data)
      console.log("🚀 ~ getDetailRoominfo ~ detailData:", this.detailData)
      this.editTitle(id, data.data.code)
    },
  },

};
</script>
<style  lang="scss" scoped>
.pagination {
  text-align: right;
  padding: 20px;
}

.section {
  .title {
    color: rgba(16, 16, 16, 100);
    font-size: 16px;
    text-align: left;
    font-family: SourceHanSansSC-regular;
    padding-left: 10px;
    position: relative;

    &::before {
      content: "";
      width: 3px;
      height: 15px;
      background: #3c7ee5 100%;
      position: absolute;
      left: 0;
      top: 20%;
    }
  }

  .content {
    width: 100%;
    display: flex;
    background: #f9f7f7;
    padding: 30px 30px 0 30px;
    margin: 10px 0 30px 0;
    color: rgba(16, 16, 16, 100);
    font-size: 14px;
    text-align: left;
    font-family: SourceHanSansSC-regular;

    .content_left,
    .content_right {
      flex: 1;

      div {
        margin-bottom: 20px;

        span {
          &:first-of-type {
            display: inline-block;
            width: 166px;
          }
        }
      }
    }

    .content_item {
      color: rgba(16, 16, 16, 100);
      font-size: 14px;
      text-align: left;
      font-family: SourceHanSansSC-bold;
    }
  }
}

table {
  tr {
    th,
    td {
      text-align: center !important;
    }
  }
}

._cloud_btn {
  display: inline-block;
  cursor: pointer;
  margin-left: -10px;
  margin-top: 5px;
  padding: 5px 18px;
  color: #61a2d7;
  font-size: 13px;

  &:focus {
    color: pink;
  }
}

::v-deep.el-table__row {
  font-size: 12px !important;
}
</style>
